<template>

<v-dialog v-model="show" id="remove-token-tracking"
	persistent max-width="400px" :fullscreen="fullscreen">

	<v-card>

		<!--Modal Title -->
		<v-toolbar flat v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }">
			<v-toolbar-title>{{ $t('compRemoveTokenTracking.title') }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon @click="show = false">
				<v-icon>mdi-window-close</v-icon>
			</v-btn>
		</v-toolbar>

		<!-- Modal Contents -->
		<v-card-text class="pa-5">

			<div class="section-title text-center">
				{{ $t('compRemoveTokenTracking.txtConfirm') }}
			</div>

			<p class="text-center">{{ $t('compRemoveTokenTracking.txtCanAddBack') }}</p>

			<div v-bind:class="{'green lighten-5': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }" class="m-2 pa-3" v-if="input.token">
				<div><strong>{{ $t('common.token.name') }}</strong>: {{ input.token.name }}</div>
				<div><strong>{{ $t('common.token.symbol') }}</strong>: {{ input.token.symbol }}</div>
				<div><strong>{{ $t('common.token.address') }}</strong>: <a :href="networkConfig.tokenURL + input.token.address" target="_blank">{{ input.token.address }}</a></div>
			</div>

			<div class="text-center my-3">

				<v-btn color="success" @click="removeTokenTracking()" :disabled="loading">
					{{ $t('compRemoveTokenTracking.btnStopTracking') }}
					<ButtonLoading v-show="loading" class="ml-3" />
				</v-btn>

			</div>

		</v-card-text>

		<v-card-actions v-if="fullscreen">
			<v-spacer></v-spacer>
			<v-btn color="primary" outlined text class="mr-3" @click="show = false">
				<v-icon>mdi-window-close</v-icon> {{ $t('common.verb.close')}}
			</v-btn>
		</v-card-actions>

	</v-card>
</v-dialog>

</template>

<script>
import { config } from '@/config'
import ButtonLoading from "@/components/ButtonLoading"
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
	name: 'RemoveTokenTracking',
	components: {
		ButtonLoading
	},
	props: {
		fullscreen: { type: Boolean, default: false},
	},
	data () {
		return {
			input: {
				token: null,
			},
			loading: false,
			show: false
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			networkConfig: 'getNetworkConfig'
		}),
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount']),
		async showForm (token) {
			this.input.token = token
			this.show = true
		},
		async removeTokenTracking () {
			this.loading = true
			const apiURL = `${config.backendAPIURL}/${this.network.id}/token-tracking/delete/${this.network.userAccount}`
			const apiData = {
				tokenAddress: this.input.token.address
			}
			try {
				await this.$http.post(apiURL, apiData)
				await this.loadAccount(true)
				this.$parent.$emit("successNotification", this.$t('compRemoveTokenTracking.successMessage', {tokenSymbol: this.input.token.symbol }))
				this.$emit('token-tracking-removed')
			} catch (err) {
				console.log(err)
			} finally {
				this.loading = false
				this.show = false
			}
		}
	},
	created () {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
